import { useSession } from '@context/sessionProvider';
import { WarningIcon } from '@icons/warning-icon';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@nextui-org/react';
import React from 'react';

const WelcomeModal: React.FC = () => {
	const { user } = useSession();
	const { isOpen, onClose } = useDisclosure({ defaultOpen: user?.isNotConfigured });

	return (
		<Modal backdrop='blur' isOpen={isOpen} onClose={onClose}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader className='flex flex-col gap-1'>Welcome!</ModalHeader>
						<ModalBody className='flex flex-col items-center gap-4'>
							<WarningIcon width='100px' height='100px' />
							<div className='items-center text-center'>
								<p>
									Please note that the preview reflects the current configuration settings but is not displayed on your
									live site. To apply the changes to the frontend, make sure to save the configuration first. Once
									saved, the timer will appear on the site according to the configured settings.
								</p>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button color='primary' onPress={onClose}>
								Ok
							</Button>
						</ModalFooter>
					</>
				)}
			</ModalContent>
		</Modal>
	);
};

export default WelcomeModal;
